<template>
  <div
    id="modal_showApp"
    class="modal fade"
  >
    <div
      class="modal-dialog modal-full"
      style="max-width:1000px"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            @click="closeModal('modal_showApp')"
          >X</button>
          <h3 class="modal-title">View Order Details</h3>
        </div>

        <div class="modal-body">
          <order-images
            v-if="detialData.order_id"
            :formData="detialData"
          />
          <!-- <div
            class="row"
            v-if="detialData.images && detialData.images.length > 0"
          >
            <div
              class="col-12 col-xs-4 col-sm-3 col-md-3 mb-4"
              v-for="(img,i) in detialData.images"
              :key="i"
              style="cursor: pointer"
              @click="showImage(img)"
            >
              <img
                :src="`${$_image_path()}${img.order_image}`"
                alt="Image"
                width="100%"
                height="150px"
                style="border-radius: 4px"
              >
            </div>
          </div> -->

          <!-- <div
            v-if="detialData.order_branch_name"
            class="col-sm-6"
          >
            <h5><strong>Order Branch: </strong>{{ detialData.order_branch_name }}</h5>
          </div>

          <div
            v-if="detialData.approve_branch_name"
            class="col-sm-6"
          >
            <h5><strong>Approve Branch: </strong>{{ detialData.approve_branch_name }}</h5>
          </div>

          <div
            v-if="detialData.deliver_branch_name"
            class="col-sm-6"
          >
            <h5><strong>Deliver Branch: </strong>{{ detialData.deliver_branch_name }}</h5>
          </div> -->

          <div class="col-sm-6">
            <h5><strong>Customer: </strong>{{ detialData.full_name }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Email: </strong> {{ detialData.email }}</h5>
          </div>

          <div class="col-sm-6">
            <h5><strong>Phone Number: </strong> {{ detialData.phone_number }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Order ID: </strong> {{ detialData.theOrderID }}</h5>
          </div>
          <!--<div class="col-sm-6"> -->
          <!--<h5 v-if="detialData.c_o_d == '1'"> <strong>Cash on Deliver: </strong> Yes</h5> -->
          <!--<h5 v-else> <strong>Cash on Deliver: </strong> No</h5> -->
          <!--</div>-->

          <div class="col-sm-6">
            <h5>
              <strong>Product url: </strong>
              <a
                :href="detialData.product_url"
                target="_blank"
              >{{
                  detialData.product_url ? detialData.product_url.replace(/http(s)?:\/\//, '').substr(0, 25) +
                    (detialData.product_url.length > 25 ? '...' : '') : detialData.product_url
                }}
              </a>
            </h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Product Name : </strong> {{ detialData.product_name }}</h5>
          </div>
          <div
            v-if="detialData.process_note"
            class="col-sm-6"
          >
            <h5><strong>Process note : </strong> {{ detialData.process_note }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.size != null"
          >
            <h5><strong>Size: </strong>{{ detialData.size }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.type != null"
          >
            <h5><strong>Type: </strong>{{ detialData.type }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Status : </strong>{{ detialData.status }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.color != null"
          >
            <h5><strong>Color: </strong>{{ detialData.color }}</h5>
          </div>
          <div class="col-sm-6">
            <h5><strong>Quantity: </strong>{{ detialData.quantity }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.coupon != null"
          >
            <h5><strong>Coupon: </strong>{{ detialData.coupon }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.coupon != null"
          >
            <h5><strong>Coupon Percentage: </strong>{{ detialData.coupon_percentage }}%</h5>
          </div>
          <div class="col-sm-6">
            <h5 v-if="detialData.delivery_type == 'office delivery'">
              <strong>Delivery Type: </strong>
              <span
                class="fa fa-building"
                style="color: teal"
              ></span>
              {{ detialData.delivery_type }}
            </h5>
            <h5 v-else>
              <strong>Delivery Type: </strong>
              <span
                class="glyphicon glyphicon-home "
                style="color:teal"
              ></span>
              {{ detialData.delivery_type }}
            </h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.confirm_date != null"
          >
            <h5><strong>Confirm Date: </strong> {{ detialData.confirm_date }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.bank_name != null"
          >
            <h5><strong>Bank name: </strong> {{ detialData.bank_name }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.cancel_reason != null"
          >
            <h5><strong>Cancel reason: </strong> {{ detialData.cancel_reason }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.quantity_charge != null"
          >
            <h5><strong>Quantity charge: </strong>${{ detialData.quantity_charge }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.the_tl_price != null"
          >
            <h5><strong>Item Price TL: </strong>tl {{ detialData.the_tl_price }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.item_price != null"
          >
            <h5><strong>Item Price USD: </strong>${{ detialData.item_price }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.tax != null"
          >
            <h5><strong>Tax: </strong>${{ detialData.tax }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.national_tax != null"
          >
            <h5><strong>International Tax: </strong>${{ detialData.national_tax }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.item_weight != null"
          >
            <h5><strong>Item Weight: </strong>{{ detialData.item_weight }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.volume != null"
          >
            <h5><strong>Volume: </strong>{{ detialData.volume }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.internal_shipping_handling != null"
          >
            <h5><strong>Int Shipping: </strong>${{ detialData.internal_shipping_handling }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.kreenex_fee != null"
          >
            <h5><strong>ShipZone Fee: </strong>${{ detialData.kreenex_fee }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.insurance != null"
          >
            <h5><strong>Insurance: </strong>${{ detialData.insurance }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.delivery_price != null"
          >
            <h5><strong>Delivery Price: </strong>${{ detialData.delivery_price }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.item_type != null"
          >
            <h5><strong>Item Type: </strong>{{ detialData.item_type }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.discount != null"
          >
            <h5><strong>Discount: </strong>{{ detialData.discount }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.total_amount != null"
          >
            <h5><strong>Total Amount: </strong>{{ detialData.total_amount | usdFormat }}</h5>
          </div>
          <div
            class="col-sm-6 red--text"
            v-if="detialData.status == 'refunded'"
          >
            <h5><strong>Refund Amount: </strong>{{ detialData.money_amount | usdFormat }}</h5>
          </div>

          <div class="col-sm-6">
            <h5>
              <strong>Warehouse: </strong>
              <span v-if="detialData.country == 'USA'">
                <flag iso="um" />
              </span>
              <span v-else-if="detialData.country == 'Turkey'">
                <flag iso="tr" />
              </span>
              <span v-else-if="detialData.country == 'China'">
                <flag iso="cn" />
              </span>
              <span v-else-if="detialData.country == 'German'">
                <flag iso="de" />
              </span>
              <span v-else-if="detialData.country == 'UK'">
                <flag iso="gb" />
              </span>
              &nbsp; {{ detialData.country }}
            </h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.from_date != null"
          >
            <h5><strong>From Date: </strong>{{ detialData.from_date }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.to_date != null"
          >
            <h5><strong>To Date: </strong>{{ detialData.to_date }}</h5>
          </div>

          <div class="col-sm-6">
            <h5><strong>Order Date: </strong>{{ detialData.order_date }}</h5>
          </div>

          <div
            v-if="detialData.track_number != null"
            class="col-sm-6"
          >
            <h5><strong>Track number: </strong> {{ detialData.track_number }}</h5>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.barcode != null"
          >
            <h5><strong>bitemid: </strong> {{ detialData.barcode }}</h5>
          </div>
          <div
            class="col-sm-6 col-md-6"
            v-if="detialData.qrcode != null"
          >
            <div class="col-xs-4 col-sm-4 col-md-3">
              <h5><strong>QrCode:</strong></h5>
            </div>
            <div class="col-xs-6 col-sm-6 col-md-4">
              <qr-code
                :text="detialData.order_id.toString()"
                :size="size"
              ></qr-code>
            </div>
          </div>

          <div
            class="col-sm-6"
            v-if="detialData.description != null"
          >
            <h5><strong>Description : </strong>{{ detialData.description }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.refund_reason != null"
          >
            <h5><strong>Refund Reason: </strong>{{ detialData.refund_reason }}</h5>
          </div>
          <div
            class="col-sm-6"
            v-if="detialData.note != null"
          >
            <h5><strong>Note: </strong>{{ detialData.note }}</h5>
          </div>
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>

    <!-- <v-dialog
      v-model="imageDialog"
      width="500"
    >
      <v-card>
        <img
          :src="`${$_image_path()}${theImg}`"
          alt=""
          width="100%"
        >
      </v-card>
    </v-dialog> -->
  </div>
</template>

<script>
export default {
  props: ['detialData', 'closeModal'],

  data() {
    return {
      imageDialog: false,
      theImg: '',
      size: 50
    }
  },

  methods: {
    showImage(img) {
      this.theImg = img.order_image
      this.imageDialog = true
    }
  }
}
</script>

<style>
.modal {
  text-align: center;
  padding: 0 !important;
}

.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-right: -4px;
}

.modal-dialog {
  display: inline-block;
  text-align: left;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/viewOrderDetails.vue